export enum EStroopEffectType {
    NONE,
    CONGRUENT,
    INCONGRUENT
}
